import * as  types from './action-types';
import { produce } from 'immer';
import { RenderMode } from 'app/types-shared';
import uniqBy from 'lodash/uniqBy';

import {
  CaseTableViewInstanceState, CaseTableViewState,
  PayloadCaseTableViewResultType
} from 'app/area/case-report/case-table-view/types-store';
import { ACTION } from './action-types';

export const INITIAL_CASE_TABLE_VIEW_INSTANCE_STATE: CaseTableViewInstanceState = {
  renderMode: RenderMode.report,
  fetching: false,
  caseTableViewResults: undefined,
  errorsExecuteFailed: undefined,
  singleSupplierUrl: undefined
};

export const INITIAL_CASE_TABLE_VIEW_STATE: CaseTableViewState = {
  instances: {},
  texts: {} as any
};

export function CaseTableViewReducer(state: CaseTableViewState = INITIAL_CASE_TABLE_VIEW_STATE,
  action: types.CaseTableActionType): CaseTableViewState {
  switch (action.type) {
    case ACTION.REPLACE_CASE_VIEW_TABLE: {
      const { instanceKey, caseTableViewResults } = action.payload as PayloadCaseTableViewResultType;
      return {
        ...state,
        instances: {
          ...state.instances,
          [instanceKey]: {
            fetching: false,
            errorsExecuteFailed: undefined,
            renderMode: RenderMode.report,
            caseTableViewResults
          }
        }
      };
    }
    case ACTION.APPEND_CASE_VIEW_TABLE: {
      const { instanceKey, caseTableViewResults } = action.payload as PayloadCaseTableViewResultType;
      const { entities } = caseTableViewResults || {};
      return {
        ...state,
        instances: {
          ...state.instances,
          [instanceKey]: {
            ...state.instances[instanceKey],
            caseTableViewResults: {
              ...state.instances[instanceKey].caseTableViewResults,
              metadata: {
                ...state?.instances?.[instanceKey]?.caseTableViewResults?.metadata,
                includedFields: uniqBy((state?.instances?.[instanceKey]?.caseTableViewResults?.metadata?.includedFields || []).
                concat((caseTableViewResults?.metadata?.includedFields || [])), 'columnName'),
                totalNumberOfResults: caseTableViewResults?.metadata?.totalNumberOfResults || 0
              },
              entities: (state?.instances?.[instanceKey]?.caseTableViewResults?.entities || []).concat(entities || [])
            },
            fetching: false
          }
        }
      };
    }
    case ACTION.REQUEST_CASE_VIEW_TABLE: {
      return produce(state, draftState => {
        draftState.instances[action.payload?.instanceKey] = {
          ...draftState.instances[action.payload?.instanceKey],
          errorsExecuteFailed: undefined,
          fetching: true
        };
        return draftState;
      });
    }
    case ACTION.CLEAR_CASE_VIEW_TABLE: {
      const { instanceKey } = action.payload as PayloadCaseTableViewResultType;
      return {
        ...state,
        instances: {
          ...state.instances,
          [instanceKey]: {
            ...INITIAL_CASE_TABLE_VIEW_INSTANCE_STATE
          }
        }
      };
    }

    case ACTION.FAIL_EXECUTE_FAVOURITE_CASE_VIEW_TABLE: {
      const { instanceKey, errorsExecuteFailed } = action.payload as { instanceKey: string; errorsExecuteFailed: string[] };
      return {
        ...state,
        instances: {
          ...state.instances,
          [instanceKey]: {
            ...state.instances[instanceKey],
            fetching: false,
            errorsExecuteFailed
          }
        }
      };
    }

    case ACTION.REMOVE_ITEM_CASE_VIEW_TABLE: {
      const { instanceKey, caseId } = action.payload as { instanceKey: string; caseId: number };
      return {
        ...state,
        instances: {
          ...state.instances,
          [instanceKey]: {
            ...state.instances[instanceKey],
            caseTableViewResults: {
              ...state.instances[instanceKey].caseTableViewResults,
              entities: state?.instances?.[instanceKey]?.caseTableViewResults?.entities?.filter(e => e?.[0].primaryKey?.value !== caseId)
            }
          }
        }
      };
    }

    case ACTION.RECEIVE_SINGLE_SUPPLIER_URL_CASE_VIEW_TABLE: {
      const { instanceKey, singleSupplierUrl } = action.payload as { instanceKey: string; singleSupplierUrl: string };
      return {
        ...state,
        instances: {
          ...state.instances,
          [instanceKey]: {
            ...state.instances[instanceKey],
           singleSupplierUrl: singleSupplierUrl
          }
        }
      };
    }

    default:
      return state;
  }
}
